module.exports = __webpack_public_path__ + "static/unicorncomfblanket2-9be35e6c84dfc275c332b79ad26c0183.jpeg";